import { createGlobalStyle } from 'styled-components';
import { colorWhite, colorText } from '@tds/core-colours';
import { helveticaNeueLight45, fontTelus } from '@tds/shared-typography';

/*
 CSS Reset
 http://meyerweb.com/eric/tools/css/reset/
 v2.0 | 20110126
 License: none (public domain)
*/
var reset = {
  'html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video': {
    border: 0,
    font: 'inherit',
    fontSize: '100%',
    margin: 0,
    padding: 0,
    verticalAlign: 'baseline'
  },

  /* HTML5 display-role reset for older browsers */
  'article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section': {
    display: 'block'
  },
  body: {
    lineHeight: 1
  },
  'ol, ul': {
    listStyle: 'none'
  },
  'blockquote, q': {
    quotes: 'none'
  },
  'blockquote::before, blockquote::after,q::before, q::after': {
    content: "''"
  },
  table: {
    borderCollapse: 'collapse',
    borderSpacing: 0
  },
  main: {
    display: 'block'
  }
};

var fontFaces = "\n/*\n Helvetica Neue Thin 35\n*/\n@font-face {\n  font-family: \"TELUS-Web\";\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url(\"https://cdn.telus.digital/thorium/core/fonts/aff68211-86bb-476d-882e-f7a3face144c.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/50d35bbc-dfd4-48f1-af16-cf058f69421d.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/278bef59-6be1-4800-b5ac-1f769ab47430.ttf\")\n      format(\"truetype\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/56be84de-9d60-4089-8df0-0ea6ec786b84.eot?#iefix\")\n      format(\"eot\");\n}\n\n/*\n Helvetica Neue eText Light 45\n*/\n@font-face {\n  font-family: \"TELUS-Web\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(\"https://cdn.telus.digital/thorium/core/fonts/etext/b8765d4b-d9a3-48b9-ac65-560e7517cf0e.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/etext/d7d2e6c6-fc3a-41a5-9b52-648e12e215b2.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/etext/cb64744b-d0f7-4ef8-a790-b60d6e3e4f21.ttf\")\n      format(\"truetype\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/etext/e0781a75-0ecb-464e-b6e9-85780ddc0921.eot?#iefix\")\n      format(\"eot\");\n}\n\n/*\n Helvetica Neue eText Roman 55\n*/\n@font-face {\n  font-family: \"TELUS-Web\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(\"https://cdn.telus.digital/thorium/core/fonts/etext/dc50c02f-3f77-4e75-b89c-e3f9bb4752e6.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/etext/ce6f5b38-1cb5-4a27-8182-583aa68b2436.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/etext/ff06cde7-e06a-4cf0-af4d-5b2f737bf544.ttf\")\n      format(\"truetype\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/etext/706ec8e5-fe4a-4518-91a6-7aba4d3d333f.eot?#iefix\")\n      format(\"eot\");\n}\n\n/*\n Helvetica Neue eText Medium 65\n*/\n@font-face {\n  font-family: \"TELUS-Web\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(\"https://cdn.telus.digital/thorium/core/fonts/etext/3e8a8b56-3cb0-4347-b670-eaaf06b76e9b.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/etext/07173950-fa69-4b65-9c71-0cf2ec00b51d.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/etext/aac5a4b8-ffd3-4529-a098-21b91bc86f9a.ttf\")\n      format(\"truetype\"),\n    url(\"https://cdn.telus.digital/thorium/core/fonts/etext/a747e1ea-ecdf-4f3d-ad47-3df9cfbee3cc.eot?#iefix\")\n      format(\"eot\");\n}\n\n/*\n Utility Icons web font\n*/\n@font-face {\n  font-family: \"TELUS Core Icons\";\n  font-style: normal;\n  font-weight: normal;\n  font-display: swap;\n  src: url(\"https://cdn.telus.digital/thorium/core/v0.4.0/core-icons.woff2\")\n      format(\"woff2\"),\n    url(\"https://cdn.telus.digital/thorium/core/v0.4.0/core-icons.woff\")\n      format(\"woff\"),\n    url(\"https://cdn.telus.digital/thorium/core/v0.4.0/core-icons.ttf\")\n      format(\"truetype\"),\n    url(\"https://cdn.telus.digital/thorium/core/v0.4.0/core-icons.eot?#iefix\")\n      format(\"eot\");\n}\n";

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

var globals = {
  '*': {
    backgroundRepeat: 'no-repeat',
    boxSizing: 'border-box',
    // only OS X
    '-moz-osx-font-smoothing': 'grayscale',
    // we put this here to overcome webkit bug when doing -webkit-transforms
    '-webkit-font-smoothing': 'antialiased',
    textRendering: 'optimizeLegibility',
    font: 'inherit',
    letterSpacing: '-0.8px',
    '&::before, &::after': {
      boxSizing: 'border-box'
    }
  },
  html: _extends_1({}, helveticaNeueLight45, {
    fontFamily: fontTelus,
    fontSize: '100%',
    fontKerning: 'normal'
  }),
  body: {
    backgroundColor: colorWhite,
    color: colorText,
    lineHeight: '1.5'
  }
};

/* eslint-disable import/prefer-default-export */
var flexMain = {
  'html, body': {
    height: '100%'
  },
  body: {
    display: 'flex',
    flexDirection: 'column'
  },
  'body > main': {
    flex: '1 0 auto'
  }
};

var fontBase = 'https://cdn.telus.digital/thorium/core/fonts/';
var iconFontBase = 'https://cdn.telus.digital/thorium/core/v0.4.0/';
var fonts = ["".concat(fontBase, "aff68211-86bb-476d-882e-f7a3face144c.woff2?v=20200302"), "".concat(fontBase, "50d35bbc-dfd4-48f1-af16-cf058f69421d.woff?v=20200302"), "".concat(fontBase, "278bef59-6be1-4800-b5ac-1f769ab47430.ttf"), "".concat(fontBase, "56be84de-9d60-4089-8df0-0ea6ec786b84.eot?#iefix"), "".concat(fontBase, "etext/b8765d4b-d9a3-48b9-ac65-560e7517cf0e.woff2?v=20200302"), "".concat(fontBase, "etext/d7d2e6c6-fc3a-41a5-9b52-648e12e215b2.woff?v=20200302"), "".concat(fontBase, "etext/cb64744b-d0f7-4ef8-a790-b60d6e3e4f21.ttf"), "".concat(fontBase, "etext/e0781a75-0ecb-464e-b6e9-85780ddc0921.eot?#iefix"), "".concat(fontBase, "etext/dc50c02f-3f77-4e75-b89c-e3f9bb4752e6.woff2?v=20200302"), "".concat(fontBase, "etext/ce6f5b38-1cb5-4a27-8182-583aa68b2436.woff?v=20200302"), "".concat(fontBase, "etext/ff06cde7-e06a-4cf0-af4d-5b2f737bf544.ttf"), "".concat(fontBase, "etext/706ec8e5-fe4a-4518-91a6-7aba4d3d333f.eot?#iefix"), "".concat(fontBase, "etext/3e8a8b56-3cb0-4347-b670-eaaf06b76e9b.woff2?v=20200302"), "".concat(fontBase, "etext/07173950-fa69-4b65-9c71-0cf2ec00b51d.woff?v=20200302"), "".concat(fontBase, "etext/aac5a4b8-ffd3-4529-a098-21b91bc86f9a.ttf"), "".concat(fontBase, "etext/a747e1ea-ecdf-4f3d-ad47-3df9cfbee3cc.eot?#iefix"), "".concat(iconFontBase, "core-icons.woff2?v=20200302"), "".concat(iconFontBase, "core-icons.woff?v=20200302"), "".concat(iconFontBase, "core-icons.ttf"), "".concat(iconFontBase, "core-icons.eot?#iefix")];

/* eslint-disable import/prefer-default-export */
var Reset = createGlobalStyle(reset, fontFaces, globals);
var GlobalFlexMain = createGlobalStyle(flexMain);

export default Reset;
export { GlobalFlexMain, fonts };
